module.exports = __webpack_public_path__ + "static/img/access_not_available_v2.41eb492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/access_not_available_v2.png
// module id = wu8s
// module chunks = 134